import { JsonProperty, Serializable, SerializerOld } from "@anna-money/anna-web-lib/serializerOld";

export enum Region {
  GB = "GB",
  AU = "AU",
}

@Serializable()
export class Config {
  constructor(
    @JsonProperty() readonly region: Region,
    @JsonProperty() readonly appUrl: string,
    @JsonProperty() readonly appVersion: string,
    @JsonProperty() readonly annaApiUrl: string,
    @JsonProperty() readonly annaMediaApiUrl: string,
    @JsonProperty() readonly businessXHost: string,
    @JsonProperty() readonly annaAuthUrl: string,
    @JsonProperty() readonly annaAuthClientId: string,
    @JsonProperty() readonly sentryDSN: string,
    @JsonProperty() readonly stripeApiKey: string,
    @JsonProperty() readonly withHotjar: "0" | "1",
    @JsonProperty() readonly webticsTrackerUrl: string,
    @JsonProperty({ required: false, type: String }) readonly gtmId: string | null,
    @JsonProperty({ required: false, type: String }) readonly matomoBaseUrl: string | null,
    @JsonProperty({ required: false, type: String }) readonly iosAppLink: string | null,
    @JsonProperty({ required: false, type: String }) readonly androidAppLink: string | null,
  ) {}
  get isAU(): boolean {
    return this.region === Region.AU;
  }
}

const serializer = new SerializerOld({ propertiesRequired: true });
const config: Config = serializer.deserialize(
  import.meta.env.MODE === "production"
    ? window.getAppConfig()
    : window.getAppConfig(
        import.meta.env.VITE_ANNA_DEV_ENV || "expstudio.k2",
        import.meta.env.VITE_ANNA_REGION || Region.GB,
      ),
  Config,
);

export const getConfig = (): Config => {
  return config;
};
